import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet } from './api';
import { IbackofficeUserData } from '../types/configuration.types';
import useUsersState from '../state/useUsersState';
const { REACT_APP_API_USERS } = process.env;

/**
 * Trae todos los usuarios desde la API y los guarda en el estado global.
 * @returns {Promise<IbackofficeUserData[]>} Lista de usuarios
 */
export const getAllUsers = async (): Promise<IbackofficeUserData[]> => {
  return apiGet<AxiosRequestConfig, IbackofficeUserData[]>(`${REACT_APP_API_USERS}/user/backoffice/listing`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Obtiene un usuario por su ID. Si no hay usuarios en el estado global, los trae de la API.
 * @param userId - ID del usuario a buscar
 * @param forceRefresh - Si es true, fuerza la recarga desde la API
 * @returns {Promise<IbackofficeUserData | undefined>} Usuario encontrado o undefined
 */
export const getUserById = async (userId: number, forceRefresh = false): Promise<IbackofficeUserData | undefined> => {
  const { users } = useUsersState.getState();

  if (users?.length === 0 || forceRefresh) {
    const freshUsers = await getAllUsers();
    return freshUsers.find(user => user?.id === userId);
  }

  return users.find(user => user?.id === userId);
};
